(function () {
  'use strict';

  angular.module('sempraWebapp').service('reverseOsmosisSubsystemUtils', reverseOsmosisSubsystemUtilsService);

  /** @ngInject */
  function reverseOsmosisSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getReverseOsmosisSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.REVERSE_OSMOSIS;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_CRPKA_REV_OSMOZA_GRE_MZS: 'OP_CRPKA_REV_OSMOZA_GRE_MZS',
      OP_TLAK_REV_OSMOZA: 'OP_TLAK_REV_OSMOZA',
      OP_FWV_REV_OSMOZA: 'OP_FWV_REV_OSMOZA',
      OP_BFV_REV_OSMOZA: 'OP_BFV_REV_OSMOZA',
      OP_CRP_REV_OSMOZA_U_RADU: 'OP_CRP_REV_OSMOZA_U_RADU',
      OP_BUTTON_9M1_BR_RESET: 'OP_BUTTON_9M1_BR_RESET',
      OP_CRO_9M1_BROJ_SATI_RADA: 'OP_CRO_9M1_BROJ_SATI_RADA',
      properties: {
        OP_CRPKA_REV_OSMOZA_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_REV_OSMOZA_GRE_MZS'),
        OP_TLAK_REV_OSMOZA: getFeedPropertiesObject('OP_TLAK_REV_OSMOZA'),
        OP_FWV_REV_OSMOZA: getFeedPropertiesObject('OP_FWV_REV_OSMOZA'),
        OP_BFV_REV_OSMOZA: getFeedPropertiesObject('OP_BFV_REV_OSMOZA'),
        OP_CRP_REV_OSMOZA_U_RADU: getFeedPropertiesObject('OP_CRP_REV_OSMOZA_U_RADU'),
        OP_BUTTON_9M1_BR_RESET: getFeedPropertiesObject('OP_BUTTON_9M1_BR_RESET'),
        OP_CRO_9M1_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CRO_9M1_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_TON_TLAK_REV_OSM: 'OP_TON_TLAK_REV_OSM', // LPS DELAY (MS)
      OP_ZADRSKA_BFV_OSMOZA: 'OP_ZADRSKA_BFV_OSMOZA', // BFV DELAY
      OP_ZADRSKA_CRPKA_OSMOZA: 'OP_ZADRSKA_CRPKA_OSMOZA', // 6M1 DELAY

      properties: {
        OP_TON_TLAK_REV_OSM: getActuatorPropertiesObject('OP_TON_TLAK_REV_OSM'),
        OP_ZADRSKA_BFV_OSMOZA: getActuatorPropertiesObject('OP_ZADRSKA_BFV_OSMOZA'),
        OP_ZADRSKA_CRPKA_OSMOZA: getActuatorPropertiesObject('OP_ZADRSKA_CRPKA_OSMOZA')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
        },
        getActuator: function (facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      }
    }

  }
})();
